import React, { Fragment } from 'react'
import NavBarSecondary from '../../components/Nav/NavBarSecondary'
import NavBarSecondaryMobile from '../../components/Nav/NavBarSecondaryMobile'
import LegalRoutes from './LegalRoutes'
import { FormattedMessage } from 'react-intl'
import { ConfigContext } from '../../App'

export default function Legal() {
  const configContext = React.useContext(ConfigContext)
  return (
    <Fragment>
      {configContext.isSmallScreen ? (
        <NavBarSecondaryMobile
          title={<FormattedMessage id='legal.legal' />}
          navBarSecondaryTab={[
            { label: <FormattedMessage id='legal.legal' />, url: '/legal' },
            { label: <FormattedMessage id='legal.policy' />, url: '/legal/policy' },
            { label: <FormattedMessage id='legal.piracy' />, url: '/legal/piracy' },
            { label: <FormattedMessage id='legal.cookies' />, url: '/legal/cookies' },
            { label: <FormattedMessage id='legal.privacy' />, url: '/legal/privacy' },
            { label: <FormattedMessage id='legal.termsOfUse' />, url: '/legal/terms' },
            { label: <FormattedMessage id='legal.cookieSettings' />, url: '/legal/cookie-settings' },
            { label: <FormattedMessage id='legal.streamingTerms' />, url: '/legal/streaming-terms' }
          ]}
        />
      ) : (
        <NavBarSecondary
          navBarSecondaryTab={[
            { label: <FormattedMessage id='legal.legal' />, url: '/legal' },
            { label: <FormattedMessage id='legal.policy' />, url: '/legal/policy' },
            { label: <FormattedMessage id='legal.piracy' />, url: '/legal/piracy' },
            { label: <FormattedMessage id='legal.cookies' />, url: '/legal/cookies' },
            { label: <FormattedMessage id='legal.privacy' />, url: '/legal/privacy' },
            { label: <FormattedMessage id='legal.termsOfUse' />, url: '/legal/terms' },
            { label: <FormattedMessage id='legal.cookieSettings' />, url: '/legal/cookie-settings' },
            { label: <FormattedMessage id='legal.streamingTerms' />, url: '/legal/streaming-terms' }
          ]}
        />
      )}
      <LegalRoutes />
    </Fragment>
  )
}
